import "../../styles/help/HelpSubscreenTemplate.css";

export default function HelpSubscreenTemplate() {
  return <p className="help-subscreen-template">Hello World</p>;
}
